const Button = {
  // The styles all button have in common
  baseStyle: {
    color: "#fff",
    fontFamily: "Rubik, 'sans-serif'",
    fontWeight: 400,
    borderRadius: "4px",
    _focus: { border: "none", outline: "none" },
  },

  sizes: {
    sm: { px: "12px", py: "8px", fontSize: "14px", lineHeight: "17px" },
    md: { px: "20px", py: "8px", fontSize: "14px", lineHeight: "16px" },
    lg: { px: "24px", py: "8px", fontSize: "14px", lineHeight: "16px" },
  },

  variants: {
    // default_primary: {
    //   bgGradient:
    //     "linear-gradient(rgb(245, 206, 0) 0%, rgb(224, 186, 62) 97.92%)",

    //   _hover: {
    //     opacity: 0.65,
    //     boxShadow:
    //       "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    //     _disabled: {
    //       bgGradient:
    //         "linear-gradient(rgb(245, 206, 0) 0%, rgb(224, 186, 62) 97.92%)",
    //     },
    //   },

    //   _active: {
    //     boxShadow:
    //       "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    //   },
    //   _focus: {
    //     boxShadow:
    //       "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
    //   },
    //   _disabled: {
    //     opacity: 0.5,
    //   },
    // },
    // yellow_primary: {
    //   bgColor: "yellow",
    // },

    // secondary: {
    //   color: "secondary.500",
    //   bgGradient: "transparent",
    //   border: "2px solid",
    //   borderColor: "secondary.500",
    //   _hover: { bg: "secondary.25" },
    //   _focus: {},
    //   _active: {
    //     bg: "secondary.500",
    //     color: "#ffffff",
    //   },
    //   _disabled: {
    //     opacity: 0.5,
    //   },
    // },

    tertiary: {
      bg: "secondary.500",
      fontWeight: "medium",
      fontSize: "sm",
      border: "2px solid",
      borderColor: "secondary.500",
      _hover: { bg: "secondary.400" },
    },

    // menuItem: {
    //   color: "#000000",
    //   w: "full",
    //   py: "10px",
    //   px: "12px",
    //   borderRadius: "0px",
    //   _active: { bg: "secondary.500", color: "#ffffff" },
    //   _focus: { bg: "secondary.500", color: "#ffffff" },
    //   _hover: { bg: "secondary.25" },
    // },

    // navItem: {
    //   color: "rgb(35, 35, 35)",
    //   bg: "#fff",
    //   w: "full",
    //   pl: "34px",
    //   justifyContent: "flex-start",
    //   borderRadius: "0px",
    //   transition: "all 0.1s ease-in 0s",
    //   _hover: {
    //     bg: "rgb(250, 231, 136)",
    //     _disabled: {
    //       bg: "#fff",
    //     },
    //   },

    //   _active: {
    //     borderLeft: "2px solid black",
    //     bg: "rgb(250, 231, 136) !important",
    //   },
    //   _focus: {
    //     bg: "#0002",
    //     boxShadow: "none",
    //   },
    //   _disabled: {
    //     opacity: 0.5,
    //   },
    // },
    // icon: {
    //   color: "rgb(35, 35, 35)",
    //   bg: "transparent",
    //   borderRadius: "1000px",
    //   transition: "all 0.1s ease-in 0s",
    //   _hover: {
    //     bg: "rgba(0, 0, 0, 0.08)",
    //     _disabled: {
    //       bg: "#fff",
    //     },
    //   },

    //   _active: {
    //     bg: "rgba(0, 0, 0, 0.14)",
    //   },
    //   _focus: {
    //     boxShadow: "none",
    //   },
    //   _disabled: {
    //     opacity: 0.5,
    //   },
    // },
    // tableIcon: {
    //   color: "rgb(0, 0, 0)",
    //   borderRadius: "1000px",
    //   transition: "all 0.1s ease-in 0s",
    //   _hover: {
    //     transform: "scale(1.1)",
    //   },
    // },
    // dropDownButton: {
    //   color: "#000000",
    //   bg: "transparent",
    //   border: "2px solid",
    //   borderColor: "secondary.500",
    //   _hover: { bg: "secondary.25", color: "secondary.500" },
    //   _active: {
    //     color: "secondary.500",
    //     fontWeight: "600",
    //   },
    //   _disabled: {
    //     opacity: 0.5,
    //   },

    //   _focus: {
    //     borderColor: "secondary.200",
    //   },
    // },
  },

  // default values for `size` and `variant`
  defaultProps: {
    size: "md",
    variant: "primary",
  },
};

export default Button;
